import { camelizeKeys } from '~/redux/api/transformers/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { DataWrapper } from '../../ApiTypes';
import { GroupServer } from './types';

export const getGroup = async (
  groupId: string,
  options: ServiceRequestConfig = {},
) => {
  const response = await managedEntities.get<DataWrapper<GroupServer>>(
    `/groups/${groupId}`,
    { showErrorToast: true, ...options },
  );
  return camelizeKeys(response.data);
};
